import styled, { css } from "styled-components";

type TextBottomBoxesItemProps = {
    paddingLeft?:string
}

export const RegisteredGuests = styled.span`
    font-weight: bold;
    font-size: 18px;
    margin-left: 40px;
` 
export const EmptyGuestText = styled.p`
    margin-left: 47px;
    font-size: 18px;
    margin-top: 25px;
`

export const BottomButtonContainer = styled.div`
    padding: 30px 0;
    margin-left: 10px;
`

export const TextBottomBoxes = styled.div`
    display: flex;
    justify-content: space-between;
`

export const TextBottomBoxesItem = styled.div`
    width: 50%;

    ${(props: TextBottomBoxesItemProps) =>
    props.paddingLeft &&
    css`
      padding-left: ${props.paddingLeft};
      
    `}
`